import { Stack } from '@qred/components-library';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import NextButton from '~/components/shared/Stepper/components/NextButton';
import SkipButton from '~/components/shared/Stepper/components/SkipButton';
import { StepStatus } from '~/enums';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import { RootState } from '~/store';
import { pushToGtmLoanAction } from '~/store/actions/gtmActions';
import { patchApplication } from '~/store/actions/loanApplicationActions';
import { updateForm } from '~/store/slices/loanApplication.slice';
import { ApiStatus } from '~/store/types/sharedTypes';

export const CheckpointFooter = () => {
  const {
    loanApplication: { apiStatus },
  } = useSelector((state: RootState) => state);
  const dispatch = useAppDispatch();
  const [buttonClicked, setButtonClicked] = useState<
    'BoostApplication' | 'CompleteLater'
  >();

  const handleBoostApplication = async () => {
    setButtonClicked('BoostApplication');
    try {
      dispatch(
        pushToGtmLoanAction({
          actionName: 'boost_application_button_pressed',
        })
      );
      dispatch(updateForm({ choseToBoostApplication: true }));
      await dispatch(patchApplication());
    } catch (_err: any) {
      dispatch(
        pushToGtmLoanAction({
          stepStatus: StepStatus.Error,
          errorMessage: _err.response?.data?.message,
        })
      );
    }
  };

  const onCompleteLaterClick = async () => {
    setButtonClicked('CompleteLater');
    dispatch(
      pushToGtmLoanAction({
        actionName: 'complete_later_button_pressed',
      })
    );
    dispatch(updateForm({ choseToBoostApplication: false }));
    await dispatch(patchApplication());
  };

  return (
    <Stack align="center">
      <NextButton
        label="Onboarding.BoostApplication"
        isLoading={
          buttonClicked === 'BoostApplication' &&
          apiStatus.patch === ApiStatus.Started
        }
        action={handleBoostApplication}
        rightIcon="east"
        disabled={apiStatus.patch === ApiStatus.Started}
      />
      <SkipButton
        label="Onboarding.CompleteLater"
        action={onCompleteLaterClick}
        isLoading={
          buttonClicked === 'CompleteLater' &&
          apiStatus.patch === ApiStatus.Started
        }
        disabled={apiStatus.patch === ApiStatus.Started}
      />
    </Stack>
  );
};
